class business {
  init() {
    this.companyAutofill();
  }

  checkFormAndSubmit(form, companyList) {
    var eMail = $('form.b2b-signup input.email-company').val();

    var actDomain = companyList.find(el => eMail.endsWith(el.domain));
    if (!actDomain) {
      $('form.b2b-signup input.name-company').val('');
      $('form.b2b-signup input.company-domain').val('');

      $('form.b2b-signup input.email-company').removeClass('is-valid-input');
      $('form.b2b-signup input.name-company').removeClass('is-valid-input');
      $('form.b2b-signup input.name-company').val('');

      form.one('submit', (e) => {
        e.preventDefault();
        this.checkFormAndSubmit(form, companyList);
      });
    } else {
      $('form.b2b-signup input.name-company').val(actDomain.name);
      $('form.b2b-signup input.company-domain').val(actDomain.domain);
      form.submit();
    }
  }

  companyAutofill() {
    const form = $('form.b2b-signup');

    const companyList = $('form.b2b-signup').data('companyList');

    if (!companyList) {
      return false;
    }

    const emailValue = $('form.b2b-signup input.email-company').val();
    if (emailValue) {
      var initialActDomain = companyList.find(el => emailValue.endsWith(el.domain));
      if (initialActDomain) {
        $('form.b2b-signup input.name-company').val(initialActDomain.name);
        $('form.b2b-signup input.company-domain').val(initialActDomain.domain);
      }
    }

    $('form.b2b-signup input.email-company').blur((e) => {
      var actDomain = companyList.find(el => e.target.value.endsWith(el.domain));
      if (actDomain) {
        $('form.b2b-signup input.name-company').val(actDomain.name);
        $('form.b2b-signup input.company-domain').val(actDomain.domain);
      } else {
        $('form.b2b-signup input.name-company').val('');
        $('form.b2b-signup input.company-domain').val('');
      }
    });

    form.one('submit', (e) => {
      e.preventDefault();
      this.checkFormAndSubmit(form, companyList);
    });
  }
}

const Business = new business();
export default Business;



// WEBPACK FOOTER //
// ./assets/scripts/components/b2b.js